export default __webpack_public_path__ + "static/media/Datchik-dvizheniya.9bbbc814.webp";